import graphql__dbc4368b5f2cc5975bbb from "./__generated__/InterviewCompletionSection_answer.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import InterviewStateCard from "./InterviewStateCard";

const InterviewCompletionSection = props => {
  const { formField, individualSummary } = useFragment(
    InterviewCompletionSection_answer,
    props.answer
  );
  const t = useFormatMessage();
  const title = t(intlMessages.interviewCompleted);
  const summaryTitle = t(intlMessages.individualSummary);

  return (
    <InterviewStateCard state="idle" className="oral-interview-completion">
      <h3 className="oral-interview-completion__title">{title}</h3>

      <div className="oral-interview-completion__summary">
        <h4 className="oral-interview-completion__summary-title">{summaryTitle}</h4>
        <p className="oral-interview-completion__summary-text">{individualSummary}</p>
      </div>

      <p className="oral-interview-completion__message">{formField.closingMessage}</p>
    </InterviewStateCard>
  );
};

const InterviewCompletionSection_answer = graphql__dbc4368b5f2cc5975bbb;

export default InterviewCompletionSection;

const intlMessages = defineMessages({
  interviewCompleted: {
    id: "answer.oralInterview.interviewCompleted",
    defaultMessage: "Entretien terminé"
  },
  individualSummary: {
    id: "answer.oralInterview.individualSummary",
    defaultMessage: "Synthèse de l'entretien"
  }
});
